import { cipo } from 'cipo';

cipo.controller('mycipodriveController',
    function ($transition$, $scope, $state, APP_CONTENT, Explorer1, userService, FileManagerConfig) {
        const routeParams = {...$transition$.params()};
        $scope.moduleName = userService.system.mNames[$state.current.code];
        $scope.module = userService.system.modules[$state.current.code];
        $scope.content = APP_CONTENT;
        // get live operations
        Object.defineProperty($scope, 'operations', {
            get: function () { return userService.getOperationsFor("MCD"); }
        });

        $scope.explorerData = FileManagerConfig.cipoDrive;

        userService.setLastVisitedModule($scope.module.moduleId);
        userService.setContextModuleNames($scope);

        $scope.loadExplorer = function (storageType) {
            $scope.explorer = new Explorer1({
                routeParams: routeParams,
                navigateTo: function (route, params) {
                    if (route) {
                        $state.go(route, params);
                    }
                    else {
                        $scope.goto({ ...params });
                    }
                },
                abbreviation: 'MCD',
                layout: 1,
                hasShare: true,
                rootName: "...",
                treeSetup: {
                    treeOptions: {
                        allowDeselect: false,
                        nodeChildren: "folders",
                        dirSelectable: true,
                        isLeaf: function (node) { if (node.id == -2 || node.id == -10) return true; else return false; },
                        multiSelection: false,
                        injectClasses: {
                            ul: "a1",
                            li: "a2",
                            liSelected: "a7",
                            iExpanded: "a3",
                            iCollapsed: "a4",
                            iLeaf: "a5",
                            label: "a6",
                            labelSelected: "a8"

                            }
                        },
                        orderby: ""
                    },
                    urlsData: storageType,
                    managerSetup: {
                        search: true,
                        customFilters: [
                            { key: "showAllPhotos", value: false, label: "Show images only", type: "checkbox" }
                        ],
                        columns: {
                            1: [
                                { name: "_name", label: 'Name', type: 'checkbox', replacementFor: "name", onTablet: true, onPhone: true, width: 30, fieldTypeId: 1 },
                                { name: "createdBy", label: 'Owner', type: 'text', onTablet: true, onPhone: false, width: 25, fieldTypeId: 1 },
                                { name: "createdOn", label: 'Created On', type: 'date', onTablet: true, onPhone: false, width: 15, fieldTypeId: 4, options: userService.userSettings().datetimeFormat },
                                { name: "updatedOn", label: 'Last Modified', type: 'date', onTablet: true, onPhone: false, width: 15, fieldTypeId: 4, options: userService.userSettings().datetimeFormat },
                                { name: "length", label: 'File Size', type: 'checkbox', onTablet: true, onPhone: false, width: 15 }
                            ],
                            2: [
                                { name: "_big_name", label: 'Name', type: 'checkbox' }
                            ]
                        },
                        searchColumns: [
                            { name: "_name", label: 'Name', type: 'checkbox', replacementFor: "name", onTablet: true, onPhone: true, width: 25, fieldTypeId: 1 },
                            { name: "folderPath", replacementFor: "folderPath", label: 'Folder', type: 'checkbox', onTablet: true, onPhone: true, width: 25, fieldTypeId: 1 },
                            { name: "createdBy", replacementFor: "createdBy", label: 'Owner', type: 'text', onTablet: true, onPhone: false, width: 20, fieldTypeId: 1 },
                            { name: "createdOn", replacementFor: "createdOn", label: 'Created On', type: 'date', onTablet: true, onPhone: false, width: 10, fieldTypeId: 4, options: userService.userSettings().datetimeFormat },
                            { name: "updatedOn", replacementFor: "updatedOn", label: 'Last Modified', type: 'date', onTablet: true, onPhone: false, width: 10, fieldTypeId: 4, options: userService.userSettings().datetimeFormat },
                            { name: "length", label: 'File Size', type: 'checkbox', onTablet: true, onPhone: false, width: 10 } // fieldTypeId: 2
                        ],
                        globalSearchColumns: [
                            { name: "_name", label: 'Name', type: 'checkbox', replacementFor: "name", onTablet: true, onPhone: true, width: 20, fieldTypeId: 1 },
                            { name: "folderPath", replacementFor: "folderPath", label: 'Folder', type: 'checkbox', onTablet: true, onPhone: true, width: 15, fieldTypeId: 1 },
                            { name: "contractName", replacementFor: "contractName", label: $scope.contractModuleName, type: 'checkbox', onTablet: true, onPhone: true, width: 15, fieldTypeId: 1 },
                            { name: "createdBy", replacementFor: "createdBy", label: 'Owner', type: 'text', onTablet: true, onPhone: false, width: 10, fieldTypeId: 1 },
                            { name: "createdOn", replacementFor: "createdOn", label: 'Created On', type: 'date', onTablet: true, onPhone: false, width: 10, fieldTypeId: 4, options: userService.userSettings().datetimeFormat },
                            { name: "updatedOn", replacementFor: "updatedOn", label: 'Last Modified', type: 'date', onTablet: true, onPhone: false, width: 10, fieldTypeId: 4, options: userService.userSettings().datetimeFormat },
                            { name: "length", label: 'File Size', type: 'checkbox', onTablet: true, onPhone: false, width: 10 } // fieldTypeId: 2
                        ],
                        recycleBinColumns: [
                            { name: "_name", label: 'Name', type: 'checkbox', replacementFor: "name", onTablet: true, onPhone: true, width: 25, fieldTypeId: 1 },
                            { name: "updatedBy", replacementFor: "updatedBy", label: 'Deleted By', type: 'text', onTablet: true, onPhone: false, width: 10, fieldTypeId: 1 },
                            { name: "updatedOn", replacementFor: "updatedOn", label: 'Deleted On', type: 'date', onTablet: true, onPhone: false, width: 20, fieldTypeId: 4, options: userService.userSettings().datetimeFormat },
                            { name: "pathWhenDeleted", replacementFor: "pathWhenDeleted", label: 'Original Location', type: 'checkbox', onTablet: true, onPhone: true, width: 20, fieldTypeId: 1 },
                            { name: "length", label: 'File Size', type: 'checkbox', onTablet: true, onPhone: false, width: 15 } // fieldTypeId: 2
                        ],
                    }
                });
            };

        $scope.loadExplorer($scope.explorerData);

        $scope.$watch(function () {
            return userService.isReloadGrid;
        },
            function (n, o) {
                if (n) {
                    if ($scope.explorer.manager) {
                        $scope.explorer.manager.loading = true;
                        $scope.explorer.manager.loadPage();
                    }
                    userService.isReloadGrid = false;
                }
            });

        $scope.goto = function (params) {
            var newParams = {
                fid: params.fid ?? -1, // folder id
                id: params.id ?? undefined, // file id
            };
            $state.go('tenant.mycipodrive', newParams, { reload: false });
        };
    });
